import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { agruparErrorHttp } from './app/compartido/utilidades/sentry.utils';

import * as Sentry from '@sentry/angular';

Sentry.init({
  dsn: 'https://8376b43c88c799e4934cd982b7123413@o4506835544834048.ingest.us.sentry.io/4506855510048768',
  integrations: [
    Sentry.browserTracingIntegration(),
    // Las grabaciones muestran la pantalla: con el texto tapado y sin imágenes, para
    // que no lleven nombres, cédulas, direcciones ni fórmulas de los pacientes
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, // Se traza el 10% de las transacciones
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.elevamedical\.com\/api/],
  // Session Replay: pocas grabaciones para no agotar la cuota del mes. Se graba el
  // 1% de las sesiones y la mitad de las que tienen un error, que son las útiles.
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.5,

  // Errores de scripts que los navegadores Android basados en WebView
  // inyectan en la página; ocurren en su código, no en el de la aplicación
  ignoreErrors: [/(x|sw)browser is not defined/],

  // Un issue por status HTTP + endpoint; si no, se agrupan por la línea del servicio
  beforeSend: (evento, pista) => agruparErrorHttp(evento, pista, environment.apiUrl),

  environment: environment.production ? 'production' : 'development',
  enabled: environment.production,

  // Los releases son a nivel de organización, así que se prefija con el
  // proyecto para no colisionar con los del backend. Debe coincidir con el
  // release que crea atlas_deploy.sh.
  release: 'atlas-frontend@' + environment.version,
});

if (environment.production) enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
